/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Shipping_N_Delivery__Question_3Inputs */

const en_help_center__shipping_n_delivery__question_3 = /** @type {(inputs: Help_Center__Shipping_N_Delivery__Question_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if my item arrives damaged?`)
};

/**
* | output |
* | --- |
* | "What if my item arrives damaged?" |
*
* @param {Help_Center__Shipping_N_Delivery__Question_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__shipping_n_delivery__question_3 = /** @type {((inputs?: Help_Center__Shipping_N_Delivery__Question_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Shipping_N_Delivery__Question_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__shipping_n_delivery__question_3(inputs)
});